import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiUsers } from "react-icons/fi";
import colors from "../Constant/colors";

const TeacherAttendance = () => {
  const [teacherList, setTeacherList] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([]);
  const [todayDate] = useState(new Date());
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingTeachers, setLoadingTeachers] = useState(true);
  const [designations, setDesignations] = useState([]);

  const currentSessionId = localStorage.getItem("currentSessionId");
const getDesignationName = (id) => {
  const d = designations.find(des => des._id === id);
  return d ? d.designationName : "N/A";
};

  /* ================= FETCH TEACHERS ================= */
  useEffect(() => {
    if (currentSessionId) {
      fetchTeachers();
    }
  }, [currentSessionId]);

  const fetchTeachers = async () => {
    try {
      setLoadingTeachers(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeachers?sessionId=${currentSessionId}`
      );

const teachers = Array.isArray(res.data) ? res.data : [];

const sessionTeachers = teachers.filter(
  t => t.sessionId?.toString() === currentSessionId?.toString()
);

const mapped = sessionTeachers.map((t) => ({
  ...t,
  attendance: "Present",
  remarks: "",
}));

setTeacherList(mapped);
setFilteredTeachers(mapped);

      fetchTodayAttendance(mapped);
    } catch (err) {
      console.error("Error fetching teachers:", err);
      alert("Failed to fetch teachers");
    } finally {
      setLoadingTeachers(false);
    }
  };
useEffect(() => {
  if (!currentSessionId) return;

  axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/getDesignations`, {
      params: { sessionId: currentSessionId, type: "Teacher" }
    })
    .then(res => setDesignations(res.data))
    .catch(err => console.error("Designation error", err));
}, [currentSessionId]);

  /* ================= FETCH TODAY ATTENDANCE ================= */
  const fetchTodayAttendance = async (teachersData) => {
    try {
      const dateStr = todayDate.toISOString().split("T")[0];

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teacherAttendances/getByDate`,
        {
          params: {
            date: dateStr,
            sessionId: currentSessionId,
          },
        }
      );

      const attendanceList = res.data?.teachers || [];

      const merged = teachersData.map((teacher) => {
        const record = attendanceList.find(
          (r) => r.teacherId.toString() === teacher._id.toString()
        );

        return record
          ? {
              ...teacher,
              attendance: record.status,
              remarks: record.remark,
            }
          : teacher;
      });

      setTeacherList(merged);
      setFilteredTeachers(merged);
    } catch (err) {
      console.error("Error fetching attendance:", err);
    }
  };

  /* ================= SEARCH ================= */
  useEffect(() => {
    const lower = searchQuery.toLowerCase();
    setFilteredTeachers(
      teacherList.filter(
        (t) =>
          t.firstName?.toLowerCase().includes(lower) ||
          t.lastName?.toLowerCase().includes(lower)
      )
    );
  }, [searchQuery, teacherList]);

  /* ================= HANDLE CHANGE ================= */
  const handleAttendanceChange = (id, field, value) => {
    setTeacherList((prev) =>
      prev.map((t) => (t._id === id ? { ...t, [field]: value } : t))
    );
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
  if (!teacherList.length) {
    alert("No teacher data found");
    return;
  }

  const payload = {
    sessionId: currentSessionId,
   date: todayDate.toISOString().split("T")[0],

    teachers: teacherList.map((t) => ({
      teacherId: t._id,
      name: `${t.firstName} ${t.lastName}`,
      designation: t.designation,
      status: t.attendance,
      remark: t.remarks,
    })),
  };

  try {
    setLoading(true);

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/teacherAttendances/createTeacherAttendance`,
      payload
    );

    alert("Attendance submitted successfully ");
  } catch (err) {
    if (err.response?.status === 409) {
      alert("Attendance already submitted for today ");
    } else {
      alert("Failed to submit attendance");
    }
  } finally {
    setLoading(false);
  }
};

  if (loadingTeachers) {
    return <div className="p-8">Loading teachers...</div>;
  }

  return (
    <div className="min-h-screen p-4 md:p-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h1 className="flex items-center gap-3 text-2xl font-bold pb-6">
          <FiUsers size={32} /> Teacher Attendance
        </h1>

        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <input
              type="text"
              placeholder="Search teacher"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="border px-3 py-2 rounded w-64"
            />

            <div className="font-semibold">
              {todayDate.toLocaleDateString("en-GB")}
            </div>
          </div>

          <table className="w-full border">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2">#</th>
                <th className="p-2">Teacher Name</th>
                <th className="p-2">Designation</th>
                <th className="p-2">Attendance</th>
                <th className="p-2">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {filteredTeachers.map((t, i) => (
                <tr key={t._id}>
                  <td className="p-2">{i + 1}</td>
                  <td className="p-2">
                    {t.firstName} {t.lastName}
                  </td>
                <td className="p-2">
  {getDesignationName(t.designation)}
</td>


                  <td className="p-2">
                    <select
                      value={t.attendance}
                      onChange={(e) =>
                        handleAttendanceChange(
                          t._id,
                          "attendance",
                          e.target.value
                        )
                      }
                      className="border rounded px-2 py-1"
                    >
                      <option>Present</option>
                      <option>Absent</option>
                      <option>On Leave</option>
                      <option>Late</option>
                    </select>
                  </td>
                  <td className="p-2">
                    <input
                      value={t.remarks}
                      onChange={(e) =>
                        handleAttendanceChange(
                          t._id,
                          "remarks",
                          e.target.value
                        )
                      }
                      className="border px-2 py-1 rounded w-full"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="text-center mt-6">
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="px-6 py-3 text-white rounded"
              style={{ background: colors.gradientPrimary }}
            >
              {loading ? "Submitting..." : "Submit Attendance"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherAttendance;
